// @flow
import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

type TProps = {
  synchronized: boolean
};

export default function DyorSettingDataSynchronizer (props: TProps) {
  // We don't want to dispatch a clearing action if we are just loading. That is
  // because we just finished synchronizing with the server, so there is no need
  // to make an API call to clear it on the server. Future changes do need to
  // sync to the server.
  const isInitializing = useRef(true);
  const dispatch = useDispatch();
  const { settingSku, skipSync } = useSelector((state) => ({
    settingSku: state.ringBuilder.setting.sku,
    skipSync: state.settingsFromServer.skipDyorDataRefresh
  }));
  const { synchronized } = props;

  useEffect(
    () => {
      if (!synchronized) return;

      if (settingSku) {
        // We have to update the cached data every time we mount because the
        // data (price, etc) might have changed since it was last cached.
        // In some situations we pre-load the dyor data from the server in the
        // initial request, so we don't need to update the data.
        if (!isInitializing.current || (isInitializing.current && !skipSync)) {
          dispatch({ type: 'CACHE_DYOR_SETTING' });
        }
      } else if (!isInitializing.current) {
        dispatch({ type: 'CLEAR_DYOR_SETTING' });
      }

      isInitializing.current = false;
    },
    [settingSku, synchronized]
  );

  return null;
}
